module.exports = __webpack_public_path__ + "fed3f024cc6d3f1685b2c113ccf36688.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/shengdi/jianjie/jianjie-bg.jpg
// module id = 1223
// module chunks = 0